import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../../environments/environment';
import { Constantes } from '../../shared/constantes';

import { ConsultaSolicitud } from '../../shared/models/consulta-solicitud';
import { Mensaje } from '../../shared/models/mensaje';

@Injectable()
export class ConsultaInternaService {
  api: string;
  servicio: string;

  constructor(private httpClient: HttpClient) {
    this.api = environment.api;
    this.servicio = Constantes.SERVICIO_INTERNO;
  }

  consultarSolicitud(consultaSolicitud: ConsultaSolicitud): Observable<Mensaje> {
    return this.httpClient.post<Mensaje>(this.api + this.servicio + 'consulta', consultaSolicitud);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/public/services/consulta-interna.service.ts